var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypeStudentSizelWeightoutlined = function SvgTypeStudentSizelWeightoutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343330",
    d: "m28.316 7.051-12-4a1 1 0 0 0-.632 0l-12 4A1 1 0 0 0 3 8v10a1 1 0 0 0 2 0V9.387l4.199 1.4a8 8 0 0 0 2.581 11.006c-2.25.882-4.195 2.478-5.617 4.66a1 1 0 1 0 1.675 1.093C9.72 24.656 12.696 23 16 23s6.279 1.656 8.163 4.546a1 1 0 0 0 1.674-1.092c-1.422-2.183-3.375-3.779-5.617-4.661a8 8 0 0 0 2.581-11l5.515-1.838a1 1 0 0 0 0-1.898zM22 15a6 6 0 1 1-10.831-3.556l4.515 1.5a1 1 0 0 0 .632 0l4.515-1.5A6 6 0 0 1 22 15m-6-4.054L7.163 8 16 5.054 24.837 8z"
  })));
};
export default SvgTypeStudentSizelWeightoutlined;